import { createAction } from '@ngrx/store';

export const adminUiInitialized = createAction('[Admin UI] Initialized');
